import qs from 'qs'

import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingRef, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingPeopleRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/People/ddl${queryString}`,
  }
}

const useTrainingPeopleQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingRef[] | undefined
>({
  getRequest: getTrainingPeopleRequest,
  getQueryKey: (params, queryObject) => [
    'training-people',
    queryObject?.activeOnly,
  ],
})

const useTrainingPeopleQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingRef[] | undefined, Error>,
) => {
  const trainingPeopleQuery = useTrainingPeopleQueryBase(undefined, queryObject, options)

  return { ...trainingPeopleQuery }
}
export default useTrainingPeopleQuery
